import { render, staticRenderFns } from "./AccountModal.vue?vue&type=template&id=0b167db8&scoped=true&"
import script from "./AccountModal.vue?vue&type=script&lang=js&"
export * from "./AccountModal.vue?vue&type=script&lang=js&"
import style0 from "./AccountModal.vue?vue&type=style&index=0&id=0b167db8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b167db8",
  null
  
)

export default component.exports